export const environment = {
    production: false,
    api: {
        urlbase: 'https://trazabilidad-biotechsa.online/msexpediente-distribuidor/public/api/',
        sigin: 'https://trazabilidad-biotechsa.online/msexpediente-distribuidor/public/api/login',
        usuarios: 'https://trazabilidad-biotechsa.online/msexpediente-distribuidor/public/api/usuarios',
        distribuidores: 'https://trazabilidad-biotechsa.online/msexpediente-distribuidor/public/api/distribuidores',
        empresas: 'https://trazabilidad-biotechsa.online/msexpediente-distribuidor/public/api/empresas',
        roles: 'https://trazabilidad-biotechsa.online/msexpediente-distribuidor/public/api/roles',
        tipos_productos: 'https://trazabilidad-biotechsa.online/msexpediente-distribuidor/public/api/tipos-productos',
        facturas: 'https://trazabilidad-biotechsa.online/msexpediente-distribuidor/public/api/facturas',
        factura_productos: 'https://trazabilidad-biotechsa.online/msexpediente-distribuidor/public/api/factura/productos',
        productos_facturados: 'https://trazabilidad-biotechsa.online/msexpediente-distribuidor/public/api/productos-facturados',
        trazabilidad_productos: 'https://trazabilidad-biotechsa.online/msexpediente-distribuidor/public/api/trazabilidad-productos',
        distribuidor: {
            facturas: 'https://trazabilidad-biotechsa.online/msexpediente-distribuidor/public/api/distribuidor/facturas/',
        }
    }
};